import React from 'react'
import './DataProcessingView.scss'
import { getIntegrationDisplayName, IntegrationServiceId } from '../../../../common/integrations'
import { RectangleIntegrationIcon } from '../../../../components/Integrations/RectangleIntegrationIcon/RectangleIntegrationIcon'
import Lottie from 'react-lottie'
import { animationData } from '../../../../assets/animations/icons8-refresh.json'

interface DataProcessingViewProps {
  serviceId: IntegrationServiceId
  title?: string
  subtitle?: string
}

export const DataProcessingView: React.FC<DataProcessingViewProps> = ({ serviceId, title, subtitle }) => {
  return (
    <div className='h-100 d-flex flex-column justify-content-center align-items-center text-center zocks-p-2.0 zocks-bg-color-gray-100'>
      <div className='d-flex align-items-center zocks-mb-1.5 zocks-gap-1'>
        <div className='icon-wrapper'>
          <div className='icon-absolute-content'>
            <RectangleIntegrationIcon serviceId={'Zocks'} />
          </div>
        </div>

        <div className='icon-wrapper'>
          <div className='spinner-absolute-center'>
            <SyncArrowSpinner />
          </div>
        </div>

        <div className='icon-wrapper'>
          <div className='icon-absolute-content'>
            <RectangleIntegrationIcon serviceId={serviceId} />
          </div>
        </div>
      </div>

      <h4 className='zocks-text-gray-900'>{title ?? "Preparing Client's profile"}</h4>
      <p className='zocks-text-gray-600'>{subtitle ?? `Organizing insights for ${getIntegrationDisplayName(serviceId)}. This may take a moment.`}</p>
    </div>
  )
}

const SyncArrowSpinner: React.FC = () => {
  const options = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  return <Lottie options={options} width={40} height={40} isClickToPauseDisabled={true} />
}
